import { map, over, lensProp } from 'ramda'
import { translationMapper } from 'commons/translation'

export const NotificationScope = {
  normal: 'normal',
  initial: 'initial',
  beacon: 'beacon',
}

export const notificationTranslationMapper = {
  fromAPI: over(lensProp('translations'), map(translationMapper.fromAPI)),
  toAPI: over(lensProp('translations'), map(translationMapper.toAPI)),
}
